import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { DateFormControl } from './date-form-control';

@Component({
  standalone: false,
  selector: 'app-date-form-control',
  templateUrl: './date-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateFormControlComponent),
      multi: true
    }
  ]
})
export class DateFormControlComponent
  extends AbstractFormControlComponent<DateFormControl>
  implements OnInit, ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() has18YearsOldRestriction: boolean = false;
  @Input() inline: boolean;

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  faCheck: any = faCheck;

  public get isInline(): boolean {
    return this.inline || false;
  }

  @Input() set maxDate(value: Date) {
    // todo: check || add logic to onChange ?
    if (this.control) {
      if (value) {
        this.control['maxDate'] = new Date(new Date(value).setHours(23, 59, 59, 999));
      } else {
        this.control['maxDate'] = value;
      }
    }
  }

  @Input() set minDate(value: Date) {
    if (this.control) {
      if (value) {
        this.control['minDate'] = new Date(new Date(value).setHours(0, 0, 0, 0));
      } else {
        this.control['minDate'] = value;
      }
    }
  }

  get maxDate(): Date {
    return this.control['maxDate'];
  }

  get minDate(): Date {
    return this.control['minDate'];
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  public get hideErrorMessages(): boolean {
    return this.control.hideErrorMessages || false;
  }

  ngOnInit(): void {
    if (this.has18YearsOldRestriction) {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 18);
      this.maxDate = date;
    }
  }

  changeDate(event: MatDatepickerInputEvent<Date>): void {
    const date = event.value as Date;

    this.control.setValue(date);
    this.control.markAsTouched();
  }

  open(): void {
    if (this.has18YearsOldRestriction && !this.control.value) {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 40);
      this.changeDate({ value: date, target: null, targetElement: null });
    }
  }
}
